
/**
 * Created by wanglimin on 2017/4/25.
 */
import css from './assets/scss/bet_winner.scss';
import tools from './assets/js/tools-qureka.js';
import DomainMgr from './assets/js/domain_mgr.js';

import DynamicIconMain from './DynamicIcon-self-analytics.js';

var languages = {
    "en": {
        "download": "Download app",
        "install": "Install Now",
        "open": "Open Now"
    }
};

var appPKGInfo = {
    appName: "Betwinner",
    pkgName: "org.betwinner.client"
};

var parmas = tools.getUrlString(location.href);
appPKGInfo.appName = parmas.n || appPKGInfo.appName;
appPKGInfo.pkgName = parmas.pk || appPKGInfo.pkgName;

function get_apk_api() {
    tools.getJson({
        url: "https://ui-mkt-api.mangacoin.net/marketing/dl?h5name=" + appPKGInfo.appName,
        type: "GET",
        success: function(res){
            var resp = JSON.parse(res);
            if(resp.status.code != -1){
                // 自动下载
                if(resp.result.url) {
                    // location.href = resp.result.url;
                }
    
                new DynamicIconMain({
                    el: "#bet_winner",
                    appName: appPKGInfo.appName,
                    pkgName: appPKGInfo.pkgName,
                    downloadLink: resp.result.url,
                    lang: languages
                });
            }else{
                console.log('加载失败, 请刷新!');
            }
        }
    });
}


function get_apk_url(ak_base64) {
    const ak_link = tools.decodeJavaBase64InBrowser(ak_base64);

    new DynamicIconMain({
        el: "#bet_winner",
        appName: appPKGInfo.appName,
        pkgName: appPKGInfo.pkgName,
        downloadLink: ak_link,
        lang: languages
    });
}

function setStaticResources() {
    const domainMgr = new DomainMgr();
    const link_origin = domainMgr.getDomainFromeLink();
    const u = new URL(location.href);
    const els = Array.from(document.querySelectorAll('[data-img]'));

    for (let el of els) {
        let data_img = el.getAttribute('data-img');
        let img_link = u.protocol + '//' + link_origin + data_img;
        if (el.tagName.toLowerCase() === 'img') {
            el.src = img_link;
        } else {
            el.style.backgroundImage = `url(${img_link})`;
        }
    }
}

function run() {
    let opts = tools.getUrlString(location.href);

    setStaticResources();
    if (opts && !!opts.ak) {
        get_apk_url(opts.ak);
    } else {
        get_apk_api();
    }
}

run();


// WEBPACK FOOTER //
// ./src/bet_winner.js